import React from "react";
import "./index.css";
// import { setNewPaper } from "../TestPage/getSetters";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import { useHistory,useLocation } from "react-router-dom";
function Footer() {
  let history = useHistory();
  let location = useLocation();
  return (
    !location.pathname.startsWith("/testPage") &&
    !location.pathname.startsWith("/404") && (
      <div className="footer  ">
        <ArrowUpwardIcon
          fontSize="large"
          className="arrow-up"
          onClick={() => window.scrollTo(0, 0)}
        />
        <div className="footer-inner d-flex flex-wrap py-3 px-2">
          <p onClick={() => history.push("/contact")}>Contact Us</p>|
          <p> Reviews</p>|
          <p onClick={() => history.push("/privacy-policy")}>Privacy Policy</p>|
          <p onClick={() => history.push("/legal")}> Legal Stuff</p>
          {/* <p onClick={() => setNewPaper()}> Sub Make</p> */}
        </div>
      </div>
    )
  );
}

export default Footer;
